import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";

const highlights = [
  "Premium quality products at competitive wholesale prices",
  "Full range for residential, commercial & industrial needs",
  "Genuine products sourced directly from authorized dealers",
  "Expert technical guidance for every project size",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-16 md:py-24 bg-white relative"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-5 relative"
          >
            <div className="relative">
              <img
                src="https://customer-assets.emergentagent.com/job_mastermall-showroom/artifacts/iernou36_WhatsApp%20Image%202026-07-02%20at%2012.11.56%20AM.jpeg"
                alt="Master Mall Nashik showroom building"
                className="w-full h-[420px] md:h-[520px] object-cover"
              />
              <div className="absolute -bottom-6 -right-6 bg-[#FFD500] p-6 max-w-[200px] hidden md:block">
                <div className="font-display font-bold text-4xl text-[#00296B] leading-none">
                  15+
                </div>
                <div className="text-[#00296B] text-sm font-semibold mt-2 leading-tight">
                  Years of trusted expertise in Nashik
                </div>
              </div>
              <div className="absolute -top-4 -left-4 w-24 h-24 border-4 border-[#FFD500] -z-0 hidden md:block" />
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="lg:col-span-7"
          >
            <div className="text-xs uppercase tracking-[0.3em] text-[#334155] font-semibold mb-4">
              — About Us
            </div>
            <h2
              className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-[#00296B] leading-tight mm-underline"
              data-testid="about-heading"
            >
              Powering Nashik&apos;s homes,{" "}
              <span className="text-[#00296B]/70">shops & industries</span>
            </h2>

            <p className="mt-8 text-base sm:text-lg text-[#334155] leading-relaxed">
              <span className="font-semibold text-[#00296B]">
                Master Mall Nashik
              </span>{" "}
              is your one-stop destination for a complete range of electrical
              products. From modular switches and premium wiring to LED lighting,
              fans, geysers and industrial switchgear — we bring together the
              best brands under one roof.
            </p>
            <p className="mt-4 text-base sm:text-lg text-[#334155] leading-relaxed">
              Built on a foundation of trust, quality and honest pricing, we
              serve homeowners, contractors, architects, retailers and
              industries across Maharashtra with unmatched expertise and
              service.
            </p>

            <ul className="mt-8 grid sm:grid-cols-2 gap-4">
              {highlights.map((h, i) => (
                <li
                  key={i}
                  data-testid={`about-highlight-${i}`}
                  className="flex items-start gap-3"
                >
                  <span className="mt-1 w-5 h-5 bg-[#FFD500] flex items-center justify-center flex-shrink-0">
                    <Check className="w-3.5 h-3.5 text-[#00296B]" strokeWidth={3} />
                  </span>
                  <span className="text-[#334155] text-sm sm:text-base">
                    {h}
                  </span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
